export const WORD_MSO_LIST_STYLE_PATTERN = /mso-list:\s*l(\d+)\s+level(\d+)/i;
export const WORD_LIST_BLOCK_SELECTOR = 'p, h1, h2, h3, h4, h5, h6';
export const WORD_LIST_MARKER_IGNORE_PATTERN = /mso-list:\s*Ignore/i;
export const ORDERED_LIST_MARKER_PATTERN = /^[\da-z]+[.)]\s*$/i;

/** Word Online wraps each list item in its own container; nesting lives only in `data-aria-level`. */
export const WORD_ONLINE_LIST_LEVEL_PATTERN = /data-aria-level=["']?\d+/i;
export const WORD_ONLINE_LIST_ITEM_SELECTOR = 'li[data-aria-level]';
export const WORD_ONLINE_LIST_CONTAINER_SELECTOR = '.ListContainerWrapper';

export const GOOGLE_DOCS_INTERNAL_GUID_PATTERN = /docs-internal-guid/i;
export const MARGIN_LEFT_STYLE_PATTERN = /margin-left:\s*[\d.]+(?:pt|px)/i;
export const LIST_STYLE_TYPE_PATTERN = /list-style-type:\s*([^;]+)/i;
/** Google Docs encodes each nest step as ~36pt of margin-left (not DOM nesting). */
export const GOOGLE_DOCS_MARGIN_INDENT_PT = 36;
